import React from "react";
import PropTypes from "prop-types";
import axios from "axios";
import RichTextEditor from "react-rte";
import { Button } from "reactstrap";
import moment from "moment";
import { API_END_POINT } from "../config";
import Cookie from "js-cookie";
const token = Cookie.get("waffle_world_access_token");

import { DateRangePicker } from "react-dates";
import "react-dates/initialize";

import Select from "react-select";
import "react-select/dist/react-select.css";

export default class GalleryForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      gallery: {
        name: "",
        image: "",
        description: "",
        userId: "5dc6d284b5e92a40bdc606e7",
      },
      hotels: [],
      hotel: "",
      startDate: null,
      endDate: null,
      focusedInput: null,
      description: RichTextEditor.createEmptyValue(),
    };
    // this.rteState = RichTextEditor.createEmptyValue();
    // API_END_POINT = 'https://admin.saaditrips.com';

    this.handleInputChange = this.handleInputChange.bind(this);
    this.postCoverBanner = this.postCoverBanner.bind(this);
  }

  componentDidMount() {
    console.log("props", this.props);
    const { match } = this.props;
    if (match.params.coverBannerId) {
      axios
        .get(`${API_END_POINT}/api/gallery/one`, {
          params: { galleryId: match.params.coverBannerId },
          headers: { "auth-token": token },
        })
        .then((response) => {
          this.setState(
            {
              gallery: response.data.object[0],
            },
            () => {
              // axios.get(`${API_END_POINT}/api/hotel/fetchById/${this.state.gallery.hotel_id}`)
              // .then((response) => {
              //   this.setState({
              //     hotel: response.data,
              //     startDate: moment(this.state.gallery.start_date),
              //     endDate: moment(this.state.gallery.end_date),
              //   })
              // })
            }
          );
        });
    }
  }

  setHotel(selectedHotel) {
    this.setState((prevState) => ({
      hotel: selectedHotel,
      gallery: {
        ...prevState.gallery,
        hotel_id: selectedHotel.ID,
      },
    }));
  }

  setDescription(description) {
    const { gallery } = this.state;
    gallery.description = description.toString("html");
    this.setState({
      gallery,
      description,
    });
  }

  handleInputChange(event) {
    const { value, name } = event.target;

    const { gallery } = this.state;
    gallery[name] = value;
    this.setState({ gallery });
  }

  // handleImages = (event) => {
  //   this.setState({ gallery: event.target.files[0] });
  // }

  handleImages = (event) => {
    const { name } = event.target;
    const { gallery } = this.state;
    gallery[name] = event.target.files[0];
    this.setState({ gallery });
  };

  postCoverBanner(event) {
    event.preventDefault();
    const { match, history } = this.props;
    const { loading, gallery } = this.state;
    this.setState({ loading: true });

    const fd = new FormData();
    Object.keys(gallery).forEach((eachState) => {
      fd.append(`${eachState}`, gallery[eachState]);
    });

    if (match.params.coverBannerId) {
      let galleryCopy = { ...gallery };
      galleryCopy.galleryId = galleryCopy._id;
      delete galleryCopy["_id"];
      delete galleryCopy["userId"];
      delete galleryCopy["date"];
      delete galleryCopy["__v"];

      const fd = new FormData();
      Object.keys(galleryCopy).forEach((eachState) => {
        fd.append(`${eachState}`, galleryCopy[eachState]);
      });
      this.setState({ gallery: galleryCopy });
      axios
        .post(`${API_END_POINT}/api/gallery/update`, fd, {
          headers: { "auth-token": token },
        })
        .then((response) => {
          if (response.status === 200) {
            window.alert(response.data.message);
            this.setState({ loading: false });
            this.props.history.goBack();
          } else {
            window.alert("ERROR");
            this.setState({ loading: false });
          }
        });
    } else {
      axios
        .post(`${API_END_POINT}/api/gallery`, fd, {
          headers: { "auth-token": token },
        })
        .then((response) => {
          if (response.status === 200) {
            window.alert(response.data.msg);
            this.setState({ loading: false });
            this.props.history.goBack();
          } else {
            window.alert("ERROR");
            this.setState({ loading: false });
          }
        });
    }
  }

  render() {
    const {
      loading,
      gallery,
      hotel,
      hotels,
      startDate,
      endDate,
      description,
      focusedInput,
    } = this.state;
    console.log(this.state);
    const toolbarConfig = {
      // Optionally specify the groups to display (displayed in the order listed).
      display: [
        "INLINE_STYLE_BUTTONS",
        "BLOCK_TYPE_BUTTONS",
        "HISTORY_BUTTONS",
        "BLOCK_TYPE_DROPDOWN",
      ],
      INLINE_STYLE_BUTTONS: [
        {
          label: "Bold",
          style: "BOLD",
          className: "custom-css-class",
        },
        {
          label: "Italic",
          style: "ITALIC",
        },
        {
          label: "Underline",
          style: "UNDERLINE",
        },
      ],
      BLOCK_TYPE_DROPDOWN: [
        {
          label: "Normal",
          style: "unstyled",
        },
        {
          label: "Large Heading",
          style: "header-three",
        },
        {
          label: "Medium Heading",
          style: "header-four",
        },
        {
          label: "Small Heading",
          style: "header-five",
        },
      ],
      BLOCK_TYPE_BUTTONS: [
        {
          label: "UL",
          style: "unordered-list-item",
        },
        {
          label: "OL",
          style: "ordered-list-item",
        },
      ],
    };
    // console.log(this.state);

    return (
      <div className="row animated fadeIn">
        <div className="col-12">
          <div className="row">
            <div className="col-md-12 col-sm-12">
              <div className="x_panel">
                <div className="x_title">
                  <h2>Galerie Details eingeben:</h2>
                </div>
                <div className="x_content">
                  <br />
                  <form
                    id="demo-form2"
                    data-parsley-validate
                    className="form-horizontal form-label-left"
                    onSubmit={this.postCoverBanner}
                  >
                    <div className="form-group row">
                      <label className="control-label col-md-3 col-sm-3">
                        Name
                      </label>
                      <div className="col-md-6 col-sm-6">
                        <input
                          required
                          type="text"
                          name="name"
                          className="form-control"
                          value={gallery.name}
                          onChange={this.handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="control-label col-md-3 col-sm-3">
                        Beschreibung
                      </label>
                      <div className="col-md-6 col-sm-6">
                        <input
                          required
                          type="text"
                          name="description"
                          className="form-control"
                          value={gallery.description}
                          onChange={this.handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="control-label col-md-3 col-sm-3">
                        Bild
                      </label>
                      <div className="col-md-6 col-sm-6">
                        <input
                          type="file"
                          accept="image/*"
                          name="image"
                          className="form-control"
                          onChange={this.handleImages}
                          // multiple
                          required
                        />
                      </div>
                    </div>

                    <div className="ln_solid" />
                    <div className="form-group row">
                      <div className="col-md-6 col-sm-6 offset-md-3">
                        <Button
                          className={`btn btn-success btn-lg ${
                            this.state.loading ? "disabled" : ""
                          }`}
                        >
                          <i
                            className={`fa fa-spinner fa-pulse ${
                              this.state.loading ? "" : "d-none"
                            }`}
                          />{" "}
                          Bestätigen
                        </Button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/GalleryForm.jsx